import { Linking } from 'react-native';

import setFlagReturnToLauncher from 'utils/deeplinks/setFlagReturnToLauncher';

export function openMarketLink(marketLink: string, appName?: string) {
    Linking.openURL(marketLink).then(() => setFlagReturnToLauncher(appName));
}
